<template>
	<v-img eager class="mx-auto" width="180" height="180" src="/assets/icon/no-data-green.svg"></v-img>
</template>

<script>

export default {
	components: {
	},
	data() {
		return {
		}
	}
};

</script>